import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import {convertSecondToTime, convertTimeToMinuteSecond} from 'lib/utils';
import {getTotalShadeDuration, getTotalEditDuration} from 'lib/playUtils';
import {CUT_LIMIT_DURATION} from 'constants/config';
import CutEditWrap from 'components/footer/CutEditWrap';

/**
 * 푸터 > 컷 편집 영역 컨테이너
 */

const limitTime = convertSecondToTime(CUT_LIMIT_DURATION);
const CONVERT_LIMIT_TIME = convertTimeToMinuteSecond(limitTime);

const CutEditWrapContainer = () => {
  const {
    cut: {shadeDuration, lists},
    editMode,
  } = useSelector(({cut, ui}: RootState) => ({
    cut,
    editMode: ui.editMode,
  }));
  const [cutTime, setCutTime] = useState('00:00');
  const [warning, setWarning] = useState('');

  /**
   * 구간 편집기는 그림자 영역으로 LIMIT 시간 계산
   * 웹 편집기는 그림자 영역 제외한 편집한 시간으로 LIMIT 계산
   * 그림자 영역 시간 변경될 떄마다 실행되는 함수
   */
  useEffect(() => {
    let totalDuration = 0;
    let color = '#1da121'; // 녹색

    if (editMode === 'section') {
      totalDuration = getTotalShadeDuration(shadeDuration);
    } else if (editMode === 'web') {
      totalDuration = getTotalEditDuration(lists);
      color = '#00a2ca'; // 파란색
    }

    let cTime = convertSecondToTime(totalDuration);

    cTime = convertTimeToMinuteSecond(cTime);
    setCutTime(cTime); // 컷 편집 시간 표시(MM:SS)
    setEditWrapTime(totalDuration, color); // 녹색
  }, [shadeDuration, lists, editMode]);

  /**
   * 총 편집시간 setState 함수
   * @param totalDuration 총 편집 시간
   */
  const setEditWrapTime = (totalDuration: number, color: string) => {
    if (totalDuration > CUT_LIMIT_DURATION) {
      // CUT_LIMIT_DURATION 넘었으면 빨간색으로 경고
      setWarning('#fa0000');
    } else {
      // 원래 색깔
      setWarning(color);
    }
  };

  return (
    <CutEditWrap
      cutTime={cutTime}
      warning={warning}
      CONVERT_LIMIT_TIME={CONVERT_LIMIT_TIME}
    />
  );
};

export default CutEditWrapContainer;
